module.exports = __webpack_public_path__ + "img/trashcan-icon.7bf07942.svg";